import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import InvalidLocationError from './components/InvalidLocationError';
import { injectWidgetScript, removeWidgetArtifacts } from './utils/widgetCleanup';

const CONFIG_API_PATH = '/api/agent-sdk/config';

type ConfigApiError = {
  success: false;
  message: string;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Dynamic route: /ent-or-gov/state-or-region/:location/:id */}
        <Route path="/:entity/:region/:location/:id" element={<WidgetScriptRoute />} />

        {/* Fallback for unknown routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

function WidgetScriptRoute() {
  const { location } = useParams<{ location: string }>();
  const [isInvalidLocation, setIsInvalidLocation] = useState(false);

  useEffect(() => {
    if (!location) {
      setIsInvalidLocation(true);
      return;
    }

    setIsInvalidLocation(false);
    localStorage.removeItem('chatbot_chat_history');

    const originalFetch = window.fetch.bind(window);

    const handleConfigResponse = async (response: Response) => {
      if (response.status !== 401) {
        return;
      }

      try {
        const body = (await response.clone().json()) as ConfigApiError;
        if (body.success === false) {
          setIsInvalidLocation(true);
          removeWidgetArtifacts();
        }
      } catch {
        setIsInvalidLocation(true);
        removeWidgetArtifacts();
      }
    };

    window.fetch = async (input, init) => {
      const response = await originalFetch(input, init);
      const url =
        typeof input === 'string'
          ? input
          : input instanceof Request
            ? input.url
            : String(input);

      if (url.includes(CONFIG_API_PATH)) {
        void handleConfigResponse(response);
      }

      return response;
    };

    injectWidgetScript(location);

    return () => {
      window.fetch = originalFetch;
      removeWidgetArtifacts();
    };
  }, [location]);

  if (isInvalidLocation) {
    return <InvalidLocationError location={location} />;
  }

  return null;
}

function NotFound() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2>404 - Page Not Found</h2>
      <p>Try navigating to <code>/gov/nj/gboe/j2h4x2</code> or <code>/ent/nj/ignatiuz/x6c55v</code></p>
    </div>
  );
}

export default App;
